// extracted by mini-css-extract-plugin
export default {"signinSuccessWrapper":"success_signinSuccessWrapper__-XdgF","signinSuccessContainer":"success_signinSuccessContainer__klsZH"};